import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useLang } from './LanguageContext';
import t from './translations';

const About = () => {
  const { lang } = useLang();
  const { about } = t[lang];
  const animation = useSpring({ opacity: 1, from: { opacity: 0 } });

  return (
    <animated.section id="about" style={animation}>
      <h2 className="work-heading">{about.heading}</h2>
      <p>{about.p1}</p>
      <p>{about.p2}</p>
      <p>{about.p3}</p>
    </animated.section>
  );
};

export default About;
